// AUTO-GENERATED by scripts/build-map.mjs — do not edit by hand.
// The SVG itself lives at public/world-map.svg and is loaded as a static asset.
export type ResolverPin = { left: number; top: number };
export const RESOLVER_PINS: Record<string, ResolverPin> = {
  "Cloudflare": {
    "left": 14.79,
    "top": 31.97
  },
  "Google": {
    "left": 16.09,
    "top": 34.23
  },
  "Quad9": {
    "left": 52.38,
    "top": 25.95
  },
  "OpenDNS": {
    "left": 17.19,
    "top": 33.17
  },
  "AdGuard": {
    "left": 59.18,
    "top": 34.7
  },
  "NextDNS": {
    "left": 29.44,
    "top": 30.54
  },
  "Yandex": {
    "left": 60.45,
    "top": 20.17
  },
  "AliDNS": {
    "left": 82.38,
    "top": 37.74
  },
  "DNSPod": {
    "left": 82.68,
    "top": 43.08
  },
  "CleanBrowsing": {
    "left": 23.11,
    "top": 36.01
  },
  "Mullvad": {
    "left": 55.02,
    "top": 17.7
  },
  "ControlD": {
    "left": 27.95,
    "top": 28.52
  },
  "Hurricane Electric": {
    "left": 16.11,
    "top": 31.02
  },
  "DNS4EU": {
    "left": 54.01,
    "top": 24.09
  }
};
